import { render, staticRenderFns } from "./ActivityImageButton.vue?vue&type=template&id=fa7e6c4c&scoped=true"
import script from "./ActivityImageButton.vue?vue&type=script&lang=ts"
export * from "./ActivityImageButton.vue?vue&type=script&lang=ts"
import style0 from "./ActivityImageButton.vue?vue&type=style&index=0&id=fa7e6c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7e6c4c",
  null
  
)

/* custom blocks */
import block0 from "./ActivityImageButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports